import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterStateSnapshot } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HubModule } from '../../hub/hub.module';
import { PerfilModule } from '../../perfil/perfil.module';
import { BloquearPantallaModule } from '../../bloquear-pantalla/bloquear-pantalla.module';
import { ReporteDetalladoRoutingModule } from './reporte-detallado-routing.module';

import { MenuModule } from '../../menu/menu.module';
import { ParcialModule } from '../../parcial/parcial.module';
import { PipesModule } from '../../pipes/pipes.module';

import { ApartadoComponent } from './apartado/lista.component';
import { CajaComponent } from './caja/lista.component';
import { CompraComponent } from './compra/lista.component';
import { TraspasoComponent } from './traspaso/lista.component';
import { VentaComponent } from './venta/lista.component';

import { AuthService } from '../../auth.service';

//crud
import { CrudService } from '../../crud/crud.service';
import { CrudModule }  from '../../crud/crud.module';
//fin crud
import { NgSelect2Module } from 'ng-select2';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReporteDetalladoRoutingModule,
    HubModule,
    PerfilModule,
    BloquearPantallaModule,
    MenuModule, 
    ParcialModule,
    CrudModule,
    NgSelect2Module,
    PipesModule
  ],
  declarations: [ 
    ApartadoComponent,
    CajaComponent,
    CompraComponent,
    TraspasoComponent,
    VentaComponent
  ],
  providers: [ AuthService, CrudService ]
})
export class ReporteDetalladoModule { }